import { Button, Chip, Stack } from '@mui/material';
import { SortKey } from 'enums/common.enum';
import { compact, isEmpty, omit, values } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { workQueueActions } from 'store/slices/workQueueSlice';
import { updateUnReconciledOrdersFilter } from 'store/thunks/workQueueThunks';

const ReconcileShipmentFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.reconcileShipment?.filter);

  const removeAllFilter = () => {
    dispatch(workQueueActions.clearSelectedIrreconcileOrders());
    dispatch(
      updateUnReconciledOrdersFilter({
        filter: {},
      })
    );
  };

  const removeFilter = (filterName) => () => {
    dispatch(
      updateUnReconciledOrdersFilter({
        filter: {
          ...filter,
          [filterName]: undefined,
        },
      })
    );
  };
  return (
    <Stack
      direction='row'
      flexWrap='wrap'
      rowGap={1}
      alignItems='center'
      sx={{ maxWidth: '60rem' }}
      spacing={1}
    >
      {filter.patientName && (
        <Chip
          label={`Name = ${filter.patientName}`}
          onDelete={removeFilter(SortKey.PATIENT_NAME)}
        />
      )}

      {filter.spOrderId && (
        <Chip
          label={`OrderId = ${filter.spOrderId}`}
          onDelete={removeFilter(SortKey.SP_ORDER_ID)}
        />
      )}

      {filter.orderNumber && (
        <Chip
          label={`Order Number = ${filter.orderNumber}`}
          onDelete={removeFilter(SortKey.ORDER_NUMBER)}
        />
      )}

      {filter.trackingNumber && (
        <Chip
          label={`Tracking Number = ${filter.trackingNumber}`}
          onDelete={removeFilter(SortKey.TRACKING_NUMBER)}
        />
      )}

      {!isEmpty(compact(values(omit(filter, 'taggedForReview')))) && (
        <Button onClick={removeAllFilter}>Remove All</Button>
      )}
    </Stack>
  );
};

export default ReconcileShipmentFilterStatusBar;
